import * as React from 'react';

function SvgHamburgerIcon(props) {
  return (<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 18" {...props}>
    <path
      fill="#fff"
      d="M20 0H0v2.118h20zM20 5.294H0v2.118h20zM20 10.588H0v2.118h20zM20 15.882H0V18h20z"
    />
  </svg>)
}
export default SvgHamburgerIcon;
